import type { UiSourceValue } from '@features/reconciliation/enums'

type Listener = () => void

// Module-level (not React context) because the connect bank modal is opened from separate React roots,
// e.g. web components, that do not share a provider.
let uiSource: UiSourceValue | undefined
const listeners = new Set<Listener>()

export const connectBankModalUiSourceStore = {
  get: () => uiSource,
  set: (value: UiSourceValue | undefined) => {
    uiSource = value
    for (const listener of listeners) {
      listener()
    }
  },
  subscribe: (listener: Listener) => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}

let pendingAutoOpenUiSource: UiSourceValue | undefined

// sks the accounts page to open the connect bank modal as soon as it is shown,
export const requestConnectBankAutoOpen = (value: UiSourceValue): void => {
  pendingAutoOpenUiSource = value
}

// Returns the source of the pending auto-open request once, or `undefined` when there is none
export const consumeConnectBankAutoOpenRequest = (): UiSourceValue | undefined => {
  const value = pendingAutoOpenUiSource
  pendingAutoOpenUiSource = undefined

  return value
}
